import { createApi } from '@reduxjs/toolkit/query/react';

import DealSystemService from 'Services/DealSystemService';
import ServiceCallService from 'Services/ServiceCallService';
import axiosBaseQuery from 'utils/axios/axiosBaseQuery';
import { getErrorMessage } from 'utils/axios/getErrorMessage';
import { RequestValidationFailedError } from 'utils/errors';

export default createApi({
  reducerPath: 'serviceCallApi',
  tagTypes: ['ServiceCallGet'],
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    get: build.query({
      queryFn: async (id, { signal }) => {
        return {
          data: await ServiceCallService.getServiceCall(id, { signal }),
        };
      },
      providesTags: ['ServiceCallGet'],
    }),

    create: build.mutation({
      queryFn: async (data, { signal }) => {
        if (!data.deal_id && data.deal_system_id) {
          const dealSystems = await DealSystemService.getByDealSystemId(
            data.deal_system_id,
            { signal },
          );
          // eslint-disable-next-line no-param-reassign
          data.deal_id = dealSystems.deal_id;
        }

        try {
          return {
            data: await ServiceCallService.createServiceCall(
              {
                contact: { id: data.contact_id },
                site: { id: data.site_id },
                deal: {
                  id: data.deal_id,
                },
                company: data.company_id ? { id: data.company_id } : null,
                title: data.title,
                type:
                  typeof data.type === 'object' ? data.type?.name : data.type,
                reason: data.reason,
                products: [],
                warranty: data.warranty,
                taxable: data.taxable,
                charges: {
                  hourly_charge: data.hourly_charge,
                  travel_fee: data.travel_fee,
                },
                force_without_company: data.force_without_company,
                deal_id: data.deal_id,
                deal_system_id: data.deal_system_id,
              },
              { signal },
            ),
          };
        } catch (error) {
          throw new RequestValidationFailedError(getErrorMessage(error));
        }
      },
    }),

    update: build.mutation({
      queryFn: async ({ id, ...data }, { signal }) => {
        try {
          return {
            data: await ServiceCallService.updateServiceCall(
              id,
              {
                contact: { id: data.contact_id },
                site: { id: data.site_id },
                deal: {
                  id: data.deal_id,
                },
                company: data.company_id ? { id: data.company_id } : null,
                title: data.title,
                type:
                  typeof data.type === 'object' ? data.type?.name : data.type,
                issue: data.reason,
                products: [],
                warranty: data.warranty,
                taxable: data.taxable,
                charges: {
                  hourly_charge: data.hourly_charge,
                  travel_fee: data.travel_fee,
                },
                deal_id: data.deal_id,
                deal_system_id: data.deal_system_id,
              },
              {
                signal,
              },
            ),
          };
        } catch (error) {
          throw new RequestValidationFailedError(getErrorMessage(error));
        }
      },
    }),
  }),
});
